import { unstable_memoTheme } from '@mui/system';
var memoTheme = unstable_memoTheme;
export default memoTheme;